import React, { useEffect, useState } from 'react';
import './Table.css';

const GridComponent = ({ data = [], hiddenViews = [], loading }) => {
  const [gridData, setGridData] = useState(data)
  const [GridhiddenViews, setHiddenViews] = useState(hiddenViews);
  const [loadingGrid,setLoadingGrid]=useState(loading)

  useEffect(() => {
    setHiddenViews(hiddenViews)
  }, [])
  useEffect(() => {
    const indexes = gridData.reduce((acc, item, idx) => {
      if (GridhiddenViews.includes(item.label)) {
        acc.push(idx);
      }
      return acc;
    }, []);
    if (indexes.length > 0) {
      indexes.map(ind => {
        var gd = Object.assign([], gridData)
        gd.splice(ind, 1)
        setGridData(gd)
      })
    }
  }, [gridData,GridhiddenViews,loadingGrid])
  return (
    <div className="grid-container">
      {gridData.map((item, index) => (
        <React.Fragment key={index}>
          <div className="grid-item">{item.label}</div>
          <div className="grid-item">{item.value}</div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default GridComponent;
